import customAxios from "../../customAxios";

import { LOCATION_AREA } from "../../routes";
import {locationNamespace} from "../../../types/location.namespace";

const searchArea = async (props: locationNamespace.area.request): Promise<any> => {
  let thisUrl = `${LOCATION_AREA}?`;

  if (props?.search && props.search.trim().length > 0) thisUrl += `&search=${props.search}`;

  if (props?.province) thisUrl += `&province=${props?.province}`;
  if (props?.limit   ) thisUrl += `&limit=${props?.limit}`;
  if (props?.city    ) thisUrl += `&city=${props?.city}`;
  if (props?.page    ) thisUrl += `&page=${props.page}`;

  try {
    return (await customAxios.get(thisUrl)).data;
  } catch (error: any) {
    console.log({LOCATION_AREA: error});
  }
};

export default searchArea;
